import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingAnimation from './LoadingAnimation';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingAnimation />;
  }

  if (!user) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/account?next=${next}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
